import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import StarRatingComponent from "react-star-rating-component";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../css/course-catelog.css";

import { CardBody, Card, Row, Col } from "reactstrap";
import "../../css/course-catelog.css";
import TextField from "@material-ui/core/TextField";

class Review extends Component {
  constructor(props) {
    super(props);
   // const courseReview = [];

    const title = "";
    const ratingstar = "";
    const decription = "";
    const rating = "";
    const timer = "";
    this.state = {
     // courseReview,
      title,
      ratingstar,
      decription,
      rating,
      timer,
      loading: false,
      textAreaCount:0,
    };
    // const buttonClassname = clsx({
    //   [classes.buttonSuccess]: success,
    // });
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount = () => {
    // this.passreview();
    window.location.assign("https://g.page/r/CfSwMKUz8_TFEB0/review", '_blank');
  };

  async passreview() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));

    axios
      .post("Learner/courseReview", formData)
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            //courseReview: res.data.courseReview,
            rating: res.data.rating,
            title: res.data.review,
            decription: res.data.decription,
            textAreaCount:res.data.decription.length
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  onStarClick(nextValue, prevValue, name) {
    this.setState({ rating: nextValue });
  }
  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.saveReviewdetails();
  }
  recalculate(value)
  {
    if(value.length <= 250)
      this.setState({ decription: value,textAreaCount:value.length })
    else
      toast.error("Please Enter description less than 250 character's");
  }
  async saveReviewdetails() {
    // console.log("loading 1 == " + this.state.loading)
    this.setState({ loading: true });
    var a =this.state.decription.trim()
    this.setState({decription:a,textAreaCount:a.length})
    if (this.state.title === "" || this.state.decription === "") {
      toast.error("All Fields are mandatory");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    }
    else if (this.state.decription.trim().length < 30 )
    {
      toast.error("Please Enter description more than 30 character's");
      this.setState({ loading: false });
      return;
    }
    else if (this.state.decription.length >250 )
    {
      toast.error("Please Enter description less than 250 character's");
      this.setState({ loading: false });
      return;
    }
    else if (this.state.rating === "") {
      toast.error("Please Give rating");
      await this.sleep(3000);
      this.setState({ loading: false });
    } else {
      var formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("ratingstar", this.state.rating);
      formData.append("title", this.state.title);
      formData.append("decription", this.state.decription);

      await axios
        .post("Learner/saveOrUpdatecourseReview", formData)

        .then((res) => {
          if (res.data.status === "200") {
            // console.log("loading 2 == " + this.state.loading);
            this.setState({ loading: false });
            // console.log("loading 3 == " + this.state.loading);
            toast.success("Thank You  For  Your Valuable Feedback !! ");
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }
  render() {
    const { rating } = this.state;
    return (
      <div>
        <Card className="bg-color1" >
          <CardBody>
          {/* <Row>
                            <Col sm={12} style={{ marginTop: "10px" }}>
                            <a href="https://g.page/r/CfSwMKUz8_TFEB0/review"  target="_blank"  rel="noreferrer">
                            <Button variant="outlined" size="small" color="primary">
                              Click here </Button>
                              </a>
                            
                            </Col>
                            </Row>  */}
          {/* <div><a href="https://g.page/r/CfSwMKUz8_TFEB0/review"  target="_blank"  rel="noreferrer"> Join with us on </a>
                             */}
                                {/* <iframe src="https://g.page/r/CfSwMKUz8_TFEB0/review" title="businessform"
                                     height="400" width="500"
                                   >click here</iframe> */}
                            {/* </div> */}

            {/* <div className="row">
            <div className="col-lg-4"></div>
              <div className="col-lg-5 text-center">
                <Card>
                  <CardBody>
                    <div class="col-lg-12 text-center">
                      <h3>Rate this course</h3>
                    </div>
                    <br />
                    <div class="col-lg-12 ">
                      Rate :
                      <h2>
                        <StarRatingComponent
                          name="rate1"
                          starCount={5}
                          value={rating}
                          onStarClick={this.onStarClick.bind(this)}
                        />
                      </h2>
                    </div>
                    <div class="col-lg-12 ">
                      <TextField
                        id="title"
                        name="title"
                        label="Title"
                        className="text-weba"
                        value={this.state.title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      />
                    </div><br /><br />
                    <div class="col-lg-12 ">
                      <TextField
                        id="outlined-multiline-flexible"
                        name="decription"
                        label="Tell others what you think about this course."
                        className="text-weba"
                        rowsMax={5}
                        value={this.state.decription}
                        // onChange={(e) =>
                        //   this.setState({ decription: e.target.value })
                        // }
                        onChange={(e) =>
                          this.recalculate(e.target.value)
                        }
                        variant="outlined"
                        required
                      />
                    <p className="text-right">{this.state.textAreaCount}/250</p>

                    </div>
                    <br />
                    <Row>
                      <Col sm={12}>
                        <center>
                          <div className="centeritem">
                            <div className="wrapper">
                              <Button
                                variant="contained"
                                color="primary"
                                //  className="buttonSuccess"
                                disabled={this.state.loading}
                                onClick={this.handleSubmit}
                              >
                                Rate
                              </Button>

                              {this.state.loading === true ? (
                                <CircularProgress
                                  size={24}
                                  color="green"
                                  className="buttonProgress1"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </center>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </div>
            </div> */}
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Review;
